package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class CreateTeamResponse(
    val message: String? = null,
    val error: String? = null,
    val seasonID: String? = null,
    val teamId: String? = null,
)
